import { gql } from "@apollo/client"

export const ENGAGEMENT_EQUITY_GRANTS_FRAGMENT = gql`
  fragment EngagementEquityGrants on EquityGrant {
    id
    planType
    equityType
    equitySubType
    grantDate
    grantShares
    grantAmount {
      currencyCode
      subunit
      subunitToUnit
      formatted
    }
    vestingScheduleMonths
    recurring
    vestingStartDate
    earlyExerciseEvent
    vestingCliffMonths
    vestingCliffShares
    status
    createdAt
    grantedInSoftware
    documents {
      id
      tags
    }
    companyValuation {
      id
      valuation {
        subunit
        subunitToUnit
        currencyCode
      }
      effectiveDate
      documents {
        id
        filename
      }
    }
    engagement {
      id
    }
  }
`

export const ENGAGEMENT_FRAGMENT = gql`
  fragment EquityEngagementFragment on Engagement {
    id
    state
    employment {
      name
    }
    company {
      id
    }
    equityGrants {
      ...EngagementEquityGrants
    }
  }
  ${ENGAGEMENT_EQUITY_GRANTS_FRAGMENT}
`
